var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTrasnfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0189 12.0816C18.4489 11.9316 17.7789 11.8516 16.9789 11.8516C15.8689 11.8516 15.4589 12.1216 14.8889 12.5516C14.8589 12.5716 14.8289 12.6016 14.7989 12.6316L13.8489 13.6416C13.0489 14.4816 11.6089 14.4916 10.8089 13.6316L9.85891 12.6316C9.82891 12.6016 9.79891 12.5716 9.76891 12.5516C9.19891 12.1216 8.78891 11.8516 7.67891 11.8516C6.87891 11.8516 6.20891 11.9316 5.63891 12.0816C3.25891 12.7216 3.25891 14.6116 3.25891 16.2716V17.2016C3.25891 19.7116 3.25891 22.5516 8.60891 22.5516H16.0489C19.5989 22.5516 21.3989 20.7516 21.3989 17.2016V16.2716C21.3989 14.6116 21.3989 12.7216 19.0189 12.0816ZM14.6589 18.9516H9.99891C9.61891 18.9516 9.30891 18.6416 9.30891 18.2516C9.30891 17.8616 9.61891 17.5516 9.99891 17.5516H14.6589C15.0389 17.5516 15.3489 17.8616 15.3489 18.2516C15.3489 18.6416 15.0389 18.9516 14.6589 18.9516Z",
    fill: "url(#paint0_linear_3780_18290)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9989 3.22078C12.9989 2.85078 12.6989 2.55078 12.3289 2.55078C11.9589 2.55078 11.6589 2.85078 11.6589 3.22078V4.55078H13.0089V3.22078H12.9989Z",
    fill: "url(#paint1_linear_3780_18290)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5389 8.97078V10.6708C19.4989 10.6508 19.4489 10.6408 19.4089 10.6308H19.3989C18.6889 10.4408 17.8989 10.3508 16.9789 10.3508C15.4389 10.3508 14.7089 10.8008 14.0489 11.3008C13.9089 11.4008 13.8089 11.5008 13.7089 11.6008L12.7589 12.6108C12.6589 12.7108 12.4989 12.7708 12.3289 12.7708C12.2489 12.7708 12.0489 12.7608 11.8989 12.6008L10.9189 11.5708C10.8189 11.4608 10.6989 11.3708 10.6689 11.3508C9.9489 10.8008 9.2189 10.3508 7.6789 10.3508C6.7589 10.3508 5.9689 10.4408 5.2489 10.6308C5.2089 10.6408 5.1589 10.6508 5.1189 10.6708V8.97078C5.1189 6.90078 5.1189 4.55078 9.5389 4.55078H11.6589V8.00078L11.0089 7.35078C10.7389 7.08078 10.3189 7.08078 10.0489 7.35078C9.7889 7.61078 9.7889 8.04078 10.0489 8.30078L11.8489 10.1008C11.8589 10.1108 11.8689 10.1108 11.8689 10.1208C11.9289 10.1708 11.9989 10.2208 12.0689 10.2508C12.1589 10.2808 12.2389 10.3008 12.3289 10.3008C12.4189 10.3008 12.4989 10.2808 12.5889 10.2508C12.6689 10.2208 12.7389 10.1708 12.8089 10.1008L14.6089 8.30078C14.8689 8.04078 14.8689 7.61078 14.6089 7.35078C14.3389 7.08078 13.9189 7.08078 13.6489 7.35078L12.9989 8.00078V4.55078H15.1189C19.5389 4.55078 19.5389 6.90078 19.5389 8.97078Z",
    fill: "url(#paint2_linear_3780_18290)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_18290",
    x1: 12.3289,
    y1: 11.8516,
    x2: 12.3289,
    y2: 22.5516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3780_18290",
    x1: 12.3339,
    y1: 2.55078,
    x2: 12.3339,
    y2: 4.55078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3780_18290",
    x1: 12.3289,
    y1: 4.55078,
    x2: 12.3289,
    y2: 12.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTrasnfer);
export default __webpack_public_path__ + "static/media/file-trasnfer.b4a7c6c61d1c269f80bef805dd0b9bee.svg";
export { ForwardRef as ReactComponent };